
export class ShiftTime {
    id: number | undefined;
    fKAccountId: number | undefined;
    name: string = "";
    hour: number = 0;
    min: number = 0;
    defaultPlannedProductionTimeMin: number = 0;
    hour2: number = 0;
    min2: number = 0;
    defaultPlannedProductionTimeMin2: number = 0;
    hour3: number = 0;
    min3: number = 0;
    defaultPlannedProductionTimeMin3: number = 0;
    start: string = "";
}
